import React, {useEffect, useState} from "react";
import WorkflowStorage from "../ABDMWorkflowStorage";
export default function WorkflowStatus() {
    const [data, setData] = useState({});
    useEffect(() => {
        const load = () => {
            setData(WorkflowStorage.get());
        };
        load();
        window.addEventListener("storage", load);
        const timer = setInterval(load, 500);
        return () => {
            clearInterval(timer);
            window.removeEventListener("storage", load);
        };
    }, []);
    const Item = ({title, value}) => (
        <tr>

            <td width="40%">
                <strong>{title}</strong>
            </td>

            <td>

                {
                    value ?
                        <span className="text-success">

                            Available

                        </span>
                        :
                        <span className="text-danger">

                            Not Available

                        </span>
                }

            </td>

        </tr>
    );
    return (
        <div className="card shadow-sm">

            <div className="card-header bg-success text-white">

                <strong>

                    Workflow Status

                </strong>

            </div>

            <div className="card-body p-0">

                <table className="table table-sm mb-0">

                    <tbody>

                    <Item title="Access Token" value={data.accessToken}/>

                    <Item title="Search Txn" value={data.txnId}/>

                    <Item title="OTP Txn" value={data.loginIdTxnId}/>

                    <Item title="X Token" value={data.xToken}/>

                    <Item title="T Token" value={data.tToken}/>

                    <Item title="ABHA Number" value={data.abhaNumber}/>

                    <Item title="ABHA Address" value={data.abhaAddress}/>

                    <Item title="Index" value={data.index}/>

                    <Item title="Mobile" value={data.mobile}/>

                    <Item title="Email" value={data.email}/>

                    </tbody>

                </table>

            </div>

        </div>
    );
}